import axios from 'axios';

const baseUrl = import.meta.env.VITE_API_BASE_URL;
const root = `${baseUrl}/calendar`;

// Unified events in a date range. filters: EventType, ExecutiveName, City,
// Priority, Status, LeadID, ClientID, search
export const fetchCalendarEvents = async (params = {}) => (await axios.get(root, { params })).data || [];
export const fetchCalendarDashboard = async () => (await axios.get(`${root}/dashboard`)).data || {};
export const fetchEventDetail = async (source, id) => (await axios.get(`${root}/event/${source}/${id}`)).data;

export const createCalendarEvent = (values) => axios.post(`${root}/events`, values);
export const updateCalendarEvent = (id, values) => axios.put(`${root}/events/${id}`, values);
export const deleteCalendarEvent = (id) => axios.delete(`${root}/events/${id}`);

export const rescheduleEvent = (source, id, StartAt) => axios.post(`${root}/reschedule`, { source, id, StartAt });
export const completeEvent = (source, id) => axios.post(`${root}/complete`, { source, id });
export const addEventNote = (source, id, note) => axios.post(`${root}/note`, { source, id, note });
